import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-[384px_auto] grid-cols-1 items-start lg:h-[calc(100vh-154px)] overflow-hidden" }
const _hoisted_2 = { class: "sticky my-6 lg:pl-6 top-6" }
const _hoisted_3 = { class: "relative grid grid-cols-2 gap-3 p-6 border border-gray-200 rounded-2xl" }
const _hoisted_4 = { class: "col-span-2" }
const _hoisted_5 = { class: "text-xl font-semibold" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs font-medium text-neutral-500"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 border-t-[3px] border-gray-200" }, null, -1)
const _hoisted_8 = { class: "col-span-1" }
const _hoisted_9 = { class: "mb-1 text-sm font-bold" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Gender", -1)
const _hoisted_11 = { class: "col-span-1" }
const _hoisted_12 = { class: "mb-1 text-sm font-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Type", -1)
const _hoisted_14 = { class: "col-span-1" }
const _hoisted_15 = { class: "mb-1 text-sm font-bold" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Minor", -1)
const _hoisted_17 = { class: "col-span-1" }
const _hoisted_18 = { class: "mb-1 text-sm font-bold" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, " Birthdate ", -1)
const _hoisted_20 = { class: "col-span-1" }
const _hoisted_21 = { class: "mb-1 text-sm font-bold" }
const _hoisted_22 = {
  key: 0,
  class: "text-xs font-medium text-neutral-500"
}
const _hoisted_23 = {
  key: 1,
  class: "text-xs font-medium text-neutral-500"
}
const _hoisted_24 = { class: "col-span-1" }
const _hoisted_25 = { class: "mb-1 text-sm font-bold" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Nationality", -1)
const _hoisted_27 = { class: "col-span-1" }
const _hoisted_28 = { class: "mb-1 text-sm font-bold" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Religion", -1)
const _hoisted_30 = { class: "col-span-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Show Profile of the Perpetrator", -1)
const _hoisted_32 = { class: "flex flex-col h-full pb-20 space-y-4 lg:p-6 lg:overflow-y-auto lg:pb-0" }
const _hoisted_33 = { class: "flex items-center justify-between" }
const _hoisted_34 = { class: "relative min-w-[265px] md:w-auto w-full" }
const _hoisted_35 = {
  type: "submit",
  class: "border-0 absolute top-0 left-0 z-[1] px-3 py-[14px] hover:bg-primary-600 rounded-l group transition",
  title: "Search cases"
}
const _hoisted_36 = { class: "flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-auto" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "block font-semibold" }, "Case History"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-normal text-gray-700" }, "Please select the Case Number to access the patient’s details linked to this perpetrator.")
], -1)
const _hoisted_38 = { class: "self-end" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium text-neutral-600" }, "Showing:", -1)
const _hoisted_40 = { class: "text-xs font-semibold" }
const _hoisted_41 = { class: "space-y-5" }
const _hoisted_42 = {
  key: 0,
  class: "w-full px-6 border-t py-7"
}

import { ref, computed, watch 	} from "vue";
import PageLoader from "@/components/loaders/PageLoader.vue"
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import CaseCard from "@/components/cards/CaseCard.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import { useRouter, useRoute } from "vue-router";
import PerpetratorService from "@/classes/Perpetrators/PerpetratorService";
import { PerpetratorShow } from "@/interfaces/PerpetratorInterface";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import { CardCaseIntervetionInterface, CardCaseFilterInterface } from "@/interfaces/Cases/Case"; 
import { BirthdayClassification } from "@/views/enums/BirthdayClassification";
import DateFormatter from "@/helpers/DateFormatter"; 
import { onIonViewWillEnter } from "@ionic/vue";
import SearchTwoIcon from "@/components/icons/searchTwoIcon.vue";
import { useNetworkStore } from "@/store/network"; 
import OnlineSynching from "@/classes/Synching/OnlineSynching";
import PerpetratorProcessor from "@/classes/Perpetrators/Offline/Processor/PerpetratorProcessor";
 

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const showFilter = ref<boolean>(false);
const loading = ref<boolean>(false);
const perpetratorId = ref<number>(route.params.perpetrator);
const item = ref<PerpetratorShow>({});
const cases = ref<CardCaseIntervetionInterface[]>([]); 
const filterSearch = ref<string | null>(route.query.case_number);
const filterDate = ref<string | null>(route.query.date);
const filterInitiatedAt = ref<string | null>(route.query.date_initiated);
const page = ref<string | null>(route.query.page);
const lastPage = ref<string | null>(null);
const rows = ref<number | null>(route.query.rows || 5);
const numRows = computed<string | null>(() => (rows.value ? rows.value + " Rows" : "All")); 
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const onlineSync = new OnlineSynching();

const filters = computed<CardCaseFilterInterface>(() => {
	return {
		case_number: filterSearch.value,
		page: page.value,
		rows: rows.value,
		date_initiated: filterInitiatedAt.value,
		date: filterDate.value,
	};
});

const getData = async (search: any = null): Promise<any> => {
	loading.value = true;
	
	if (search) {
		filterSearch.value = search;
	}

    const response = await PerpetratorService.view(
		perpetratorId.value,
		pickBy({ ...filters.value }),
        isNetworkAvailable.value
	);

    if (response?.status === 200 || response?.data != undefined) {
		item.value = response.data.item;
        if (isNetworkAvailable.value) {
            await PerpetratorProcessor.syncToOfflinePerpetrator(perpetratorId.value, item.value);
        }
        loading.value = false;
    } else {
        loading.value = false;
        console.log(response)
    }
};

const getCases = async (search: any = null): Promise<any> => {

    const response = await PerpetratorService.cases(
		perpetratorId.value,
		pickBy({ 
			...filters.value, 
			query: search
		}),
        isNetworkAvailable.value
	);

    if (response?.status === 200 || response?.data != undefined) {
        cases.value = response.data.items
        if (cases.value) {
			page.value = response.data.items.current_page;
			lastPage.value = response.data.items.last_page;
            console.log(page.value, lastPage.value);
		}
        loading.value = false;
    } else {
        loading.value = false;
        console.log(response)
    }
};

const reloadPage = async () => {
	return await router.push({
		path: `/perpetrator/${perpetratorId.value}/view`,
		query: pickBy(filters.value),
	});
};

const applyFilters = (search: any = null) => {
	reloadPage().then(() => {
		getCases(search);
		showFilter.value = false;
	});
};

const applyReset = () => {
	filterDate.value = "";
	filterInitiatedAt.value = "";
	reloadPage().then(() => {
		getData();
		showFilter.value = false;
	});
};

const changeRows = (row: any): void => {
	rows.value = row;
	applyFilters();
};

const paginate = (data: number): void => {
	page.value = data;
	applyFilters();
};

/**
 * WATCHERS
 */
watch(
	() => filterSearch.value,
	throttle((val: string) => {
        page.value = 1;
		applyFilters(val);
	}, 1000)
);

watch(
    () => isNetworkAvailable.value,
    async () => {
        loading.value = false;
        await getData();
        await getCases();
        await onlineSync.checkDrafts();
    }
);
 
onIonViewWillEnter(async () => {
    await getData();
    await getCases();
    await onlineSync.checkDrafts()
});
 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: "/perpetrator/index",
    mainCustomClass: "resetView"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(item.value?.name), 1),
              (item.value?.nickname)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "“" + _toDisplayString(item.value?.nickname) + "”", 1))
                : _createCommentVNode("", true)
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(item.value?.gender_meta?.description), 1),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(item.value?.identity_meta?.description), 1),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, _toDisplayString(item.value?.is_mino ? "Yes" : "No"), 1),
              _hoisted_16
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(item.value?.birthdate ? _unref(DateFormatter).customDateFormat(item.value?.birthdate, 'MM/dd/yyy') : 'Unknown') + "  ", 1),
              _hoisted_19
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("p", _hoisted_21, _toDisplayString(item.value?.computed_age) + "  ", 1),
              (_unref(BirthdayClassification).APPROXIMATE_AGE == item.value.birthday_classification)
                ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Approximate Age "))
                : (_openBlock(), _createElementBlock("p", _hoisted_23, " Age "))
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("p", _hoisted_25, _toDisplayString(item.value?.nationality?.name), 1),
              _hoisted_26
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("p", _hoisted_28, _toDisplayString(item.value?.religion?.name), 1),
              _hoisted_29
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
								_unref(router).push(
									`/perpetrator/${perpetratorId.value}/edit`
								)
							))
              }, [
                _createVNode(ButtonComponent, {
                  customClass: "quaternary w-full",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", _hoisted_35, [
                _createVNode(SearchTwoIcon, { class: "w-5 h-5 object-contain grayscale brightness-[0.3] group-hover:invert group-hover:brightness-0 transition" })
              ]),
              _createVNode(TextInput, {
                type: "text",
                placeholder: "Search Cases",
                name: "search_cases",
                id: "search_cases",
                customClass: "!pl-12 frm-input search",
                modelValue: filterSearch.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterSearch).value = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("button", {
                type: "button",
                class: "flex items-center px-3 py-2 space-x-1 transition border border-solid rounded border-neutral-100 hover:bg-primary-100 w-max",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showFilter.value = true))
              }, [
                _hoisted_39,
                _createElementVNode("span", _hoisted_40, "All Records (" + _toDisplayString(cases.value?.total) + ")", 1)
              ]),
              _createVNode(FilterPanel, {
                show: showFilter.value,
                onClose: _cache[5] || (_cache[5] = ($event: any) => (showFilter.value = false)),
                "onApply:reset": _cache[6] || (_cache[6] = ($event: any) => (applyReset())),
                "onApply:filters": _cache[7] || (_cache[7] = ($event: any) => (applyFilters()))
              }, {
                fields: _withCtx(() => [
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(DatePicker, {
                      id: "date_initiated",
                      name: "date_initiated",
                      label: "Date Initiated",
                      range: true,
                      modelValue: filterInitiatedAt.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterInitiatedAt).value = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(DatePicker, {
                      id: "date_created",
                      name: "date_created",
                      label: "Date Created",
                      modelValue: filterDate.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterDate).value = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["show"])
            ])
          ]),
          (cases.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cases.value.data, (item) => {
                  return (_openBlock(), _createBlock(CaseCard, {
                    key: item,
                    routeLink: `/patient/${
								item?.patient_id
							}/cases/${
								item.id || item.bid
							}/edit`,
                    date: item?.initiated_at_formatted,
                    caseNumber: item?.case_number,
                    primaryDiagnosis: item?.diagnoses?.primary_diagnoses?.name,
                    comorbidList: item?.comorbidities?.map((item) => item.name),
                    perpetratorList: item?.perpetrators?.map((item) => item.name)
                  }, null, 8, ["routeLink", "date", "caseNumber", "primaryDiagnosis", "comorbidList", "perpetratorList"]))
                }), 128)),
                (cases.value.data?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createVNode(MinifyPagination, {
                        numRows: numRows.value,
                        "onUpdate:rows": _cache[8] || (_cache[8] = (value) => changeRows(value)),
                        "onUpdate:page": _cache[9] || (_cache[9] = (value) => paginate(value)),
                        "current-page": page.value,
                        "last-page": lastPage.value
                      }, null, 8, ["numRows", "current-page", "last-page"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})